import { Box, Typography } from '@mui/material';
import { FC } from 'react';

import { Colors } from '@/assets';

interface IProps {
    number: number;
}
export const StatisticalStatus: FC<IProps> = ({ number }) => {
    return (
        <Box
            sx={{
                background: Colors.mintCreamWhite,
                borderRadius: 4,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                px: 1,
                py: 0.4
            }}
        >
            <Typography sx={{ fontSize: 10, color: Colors.mountainMeadowGreen }} className="fas fa-arrow-up"></Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, color: Colors.watercourseGreen }}>
                {number}%
            </Typography>
        </Box>
    );
};
